module.exports.Options = [
  {
    faceselect: [
      { key: 0, value: "강아지" },
      { key: 1, value: "강아지(큰 귀)" },
      { key: 2, value: "강아지(접힌 귀)" },
      { key: 3, value: "고양이(접힌 귀)" },
      { key: 4, value: "고양이(작은 귀)" },
      { key: 5, value: "곰돌이" },
      { key: 6, value: "토끼" },
      { key: 7, value: "쥐돌이" },
      { key: 8, value: "햄스터" },
    ],
  },
  {
    colorselect: [
      { key: 0, value: "라이트브라운" },
      { key: 1, value: "베이지" },
      { key: 2, value: "브라운" },
      { key: 3, value: "살구" },
      { key: 4, value: "아이보리" },
      { key: 5, value: "화이트" },
      { key: 6, value: "차콜" },
      { key: 7, value: "민트" },
      { key: 8, value: "블랙" },
      { key: 9, value: "라이트그레이" },
      { key: 10, value: "레드" },
      { key: 11, value: "포레스트" },
      { key: 12, value: "미드나잇" },
      { key: 13, value: "코발트블루" },
      { key: 14, value: "퍼플" },
      { key: 15, value: "오렌지" },
    ],
  },
  {
    eyesselect: [
      { key: 0, value: "순정만화눈" },
      { key: 1, value: "맑은눈" },
      { key: 2, value: "화난눈" },
      { key: 3, value: "점눈(큰)" },
      { key: 4, value: "점눈(기본)" },
      { key: 5, value: "ㅡㅡ눈(기본)" },
      { key: 6, value: "점눈(작은)" },
      { key: 7, value: "반달눈(상향)" },
      { key: 8, value: "반달눈(하향)" },
      { key: 9, value: "감은눈(기본)" },
      { key: 10, value: "질끈눈" },
      { key: 11, value: "골뱅이눈" },
    ],
  },
  {
    mouthselect: [
      { key: 0, value: "이빨입(뾰족)" },
      { key: 1, value: "이빨입(기본)" },
      { key: 2, value: "닫은입(작은)" },
      { key: 3, value: "닫은입(기본)" },
      { key: 4, value: "웃는입(작은)" },
      { key: 5, value: "웃는입(큰)" },
      { key: 6, value: "놀란입(작은)" },
      { key: 7, value: "놀란입(큰)" },
      { key: 8, value: "면접광탈입" },
      { key: 9, value: "과자먹는입" },
      { key: 10, value: "메롱입" },
    ],
  },
  {
    accselect: [
      { key: 0, value: "악세서리x" },
      { key: 1, value: "하와이안 꽃" },
      { key: 2, value: "동글이 안경" },
      { key: 3, value: "모노클" },
      { key: 4, value: "썬글라스" },
      { key: 5, value: "MIC" },
      { key: 6, value: "땀땀" },
      { key: 7, value: "열받음" },
      { key: 8, value: "하트하트" },
      { key: 9, value: "수면안대" },
      { key: 10, value: "셜록모자" },
      { key: 11, value: "빨간리본" },
      { key: 12, value: "뿌애애앵 " },
      { key: 13, value: "반짝이는 눈" },
      { key: 14, value: "짜빠게티 요리사" },
      { key: 15, value: "버버리마스크" },
      { key: 16, value: "제주감귤" },
      { key: 17, value: "나뭇잎 하나" },
      { key: 18, value: "큰나뭇잎 하나" },
      { key: 19, value: "식사준비완료" },
      { key: 20, value: "사슴" },
      { key: 21, value: "유니콘" },
      { key: 22, value: "반창고" },
      { key: 23, value: "반창고2" },
      { key: 24, value: "열이나요" },
      { key: 25, value: "칼들기" },
      { key: 26, value: "악마" },
      { key: 27, value: "천사" },
      { key: 28, value: "화관" },
      { key: 29, value: "다들집중!" },
      { key: 30, value: "플렉스" },
    ],
  },
  {
    patternselect: [
      { key: 0, value: "무늬x" },
      { key: 1, value: "칼자국 흉터" },
      { key: 2, value: "발그레" },
      { key: 3, value: "호랑이" },
      { key: 4, value: "해리포터 번개" },
      { key: 5, value: "사고뭉치" },
      { key: 6, value: "주근깨" },
    ],
  },
  {
    backgroundselect: [
      { key: 0, value: "코발트블루" },
      { key: 1, value: "레드" },
      { key: 2, value: "옐로우" },
      { key: 3, value: "피치" },
      { key: 4, value: "바이올렛" },
      { key: 5, value: "스카이블루" },
      { key: 6, value: "민트" },
      { key: 7, value: "핫핑크" },
      { key: 8, value: "그린티" },
      { key: 9, value: "제주감귤" },
      { key: 10, value: "짙은차콜" },
      { key: 11, value: "아이보리" },
    ],
  },
];
